import React, {useState} from 'react'

import {Table, Row, Button, Col} from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { newProduto } from '../../store/produto.domain';
import { newComposicao } from '../../store/composicao.domain';


import { atualizaProduto } from '../../store/cadastro-produto.reducer';
import { Estoque } from '../../../../Numeros/estoque';
 

const Composicoes = ()=> {

    const {produto:dadosProduto} = useSelector(state=> state.produto);

    const produto = newProduto(dadosProduto);

    const [composicoesSelecionadas, setComposicoesSelecionadas] = useState([]);
    
    const dispatch = useDispatch();

    const dataSource = produto.composicao.map(comp => comp.toPlainJson())

    const botaoDesabilitado = ()=> {
        return composicoesSelecionadas.length == 0;
    } 

    const removeComposicaoDoProduto = () => {
        const produtoNovo = newProduto(dadosProduto);

        composicoesSelecionadas.forEach(composicao => {
            produtoNovo.removeComposicaoDoProduto(newComposicao(composicao));
        })

        dispatch(atualizaProduto(produtoNovo.toPlainJson()));
        setComposicoesSelecionadas([]);
    }

    return <Row gutter={[8, 8]}>
        <Col span={24} style={{textAlign: "right"}}>
            <Button onClick={removeComposicaoDoProduto} disabled={botaoDesabilitado()} type={"danger"}>Remover</Button>
        </Col>
        
        <Col span={24}>

            <Table
                rowKey={"uuid"}
                rowSelection={{
                    type: "checkbox",
                    onChange: (selectedRowKeys, selectedRows) => {
                        setComposicoesSelecionadas(selectedRows);
                        console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
                    },
                }}
                size={"small"}
                dataSource={dataSource}
                pagination={false}
                columns={[{
                    key: "produto",
                    title: "Produto",
                    render: (text, record, index) => {
                        return (<span style={{
                                display: "block",
                                fontWeight: "bold"
                            }}>
                            
                            {record.produto.descricao}
                            <span style={{
                                display: "block",
                                color: '#999',
                                fontWeight: "normal",
                                fontSize: "11px"
                            }}>
                                {record.produto.codigo}
                            </span>
                        </span>)
                    }
                },{
                    title: <span style={{display: 'block', textAlign: "right"}}>Quantidade</span>,
                    dataIndex: ["produto", "uuid"],
                    render: (text, record, index)=> {
                        console.log("record", record)
                        return <span style={{
                            display: "block",
                            textAlign: "right"
                        }}>
                            <Estoque value={record.quantidadeUtilizada} unMedida={record.produto.uCom} />
                        </span>
                    }
                }]}
                />
        </Col>

      
    </Row>
}

export {Composicoes}